
<div class="page-header">
    <a routerLink="/landen/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "countries.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-country-detail-form [country]="country$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>